import type { History } from "history";
import { clearCasesClientScope, clearCasesListScope, setClientIdFilter } from "store/casesSlice";
import {
  clearViewClientsAndCreateNewCase,
  setCreateNewCaseForSelectedClient,
  setViewClientsActiveCases,
} from "store/casesClientSearchSlice";
import type { AppDispatch } from "types/store";

export type NavigateToClientCasesOptions = {
  openCreateCase?: boolean;
};

function resolveClientId(client: Record<string, unknown>): number | string | null {
  const raw = client.client_id;
  if (raw === null || raw === undefined || String(raw).trim() === "") return null;
  return raw as number | string;
}

export function navigateToCasesList(dispatch: AppDispatch, history: History): void {
  dispatch(clearCasesClientScope());
  dispatch(clearViewClientsAndCreateNewCase());
  history.push("/cases");
}

export function navigateToClientCases(
  dispatch: AppDispatch,
  history: History,
  client: Record<string, unknown>,
  options?: NavigateToClientCasesOptions
): void {
  const clientId = resolveClientId(client);
  if (clientId === null) return;

  dispatch(clearCasesListScope());
  dispatch(setClientIdFilter(clientId));
  dispatch(setViewClientsActiveCases(client));
  if (options?.openCreateCase) {
    dispatch(setCreateNewCaseForSelectedClient(true));
  }
  history.push("/cases");
}
